module.exports = __webpack_public_path__ + "static/media/rm_06-24.55c516fd.png";